import { Component } from '@angular/core';

@Component({
  selector: 'app-feedback-demo',
  templateUrl: './feedback-demo.component.html',
  styleUrls: ['./feedback-demo.component.scss'],
})
export class FeedbackDemoComponent {}
